"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DMX_UNIVERSES_LIMIT = void 0;
exports.DMX_UNIVERSES_LIMIT = {
    lite: 0,
    plus_v2: 1,
    /** @deprecated */ pro: 1,
    pro_v2: 1,
    /** @deprecated */ premium: 1,
    premium_v2: 1,
    /** @deprecated */ ultimate: 1,
    ultimate_v2: Infinity,
};
//# sourceMappingURL=dmx.js.map